import React from "react";
import { Link } from "react-router-dom";

const NotFound = () => {
  return (
    <div className="flex flex-col items-center justify-center h-screen bg-gray-100">
      <h1 className="md:text-4xl text-2xl font-bold text-red-500">404 - ページが見つかりません</h1>
      <p className="text-gray-600 mt-2">お探しのページは存在しません。</p>
      <Link to="/" className="mt-4 px-4 py-2 text-white rounded-lg shadow-md bg-primary font-bold text-lg transition-transform transform hover:scale-105">
        ホームへ戻る
      </Link>
    </div>
  );
};

export default NotFound;
